import React, { Fragment, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useTheme } from 'react-jss'

import { formatCurrency, dateToLocaleString, dateToMonth } from 'helpers'

import confirmationStyles from './confirmation-style'
import classNames from 'classnames'

export default function SubscriptionConfirmation({ order, offer, products = [], subscription }) {
  const { t, i18n } = useTranslation()
  const { theme } = useTheme()
  const classes = confirmationStyles(theme)

  const amount = useMemo(() => order.operation && formatCurrency(order.operation.amount, offer.currency, i18n.language), [i18n, offer, order])
  const orderedAt = useMemo(() => order.operation && dateToLocaleString(order.operation.success_at, i18n.language), [i18n, order])

  const offerName = (offer.locales[i18n.language] || offer.locales['en']).name

  return (
    <Fragment>
      <div className={classes.help}>
        <p>{t('portal.offers.subscription_help')}</p>
      </div>
      <div>
        <p className={classes.subscriptionRecapTitle}>{t('subscription.confirmation.detail')}</p>
        <ul className={classes.subscriptionList}>
          <li className={classes.subscriptionItem}>
            <span dangerouslySetInnerHTML={{ __html: t('subscription.confirmation.reference', { reference: order.client_reference }) }} />
          </li>
          <li className={classes.subscriptionItem}>
            <span dangerouslySetInnerHTML={{ __html: t('subscription.confirmation.amount', { amount }) }} />
            </li>
          <li className={classes.subscriptionItem}>
            <span dangerouslySetInnerHTML={{ __html: t('subscription.confirmation.ordered_at', { date: orderedAt, interpolation: { escapeValue: false } }) }} />
            </li>
        </ul>

        <table className={classes.table}>
          <thead>
            <tr className={classNames(classes.thead, classes.row)}>
              <td>Produit</td>
              <td>Période</td>
              <td className={classes.priceCell}>Prix HT</td>
              <td className={classes.priceCell}>Prix TTC</td>
            </tr>
          </thead>
          <tbody>
            {products.map(product => (
              <tr key={product.starts_at} className={classes.row}>
                <td>{offerName}</td>
                <td>{dateToMonth(product.starts_at)}</td>
                <td className={classes.priceCell}>{formatCurrency(product.price_ht, offer.currency, i18n.language)}</td>
                <td className={classes.priceCell}>{formatCurrency(product.price_ttc, offer.currency, i18n.language)}</td>
              </tr>)
            )
            }
          </tbody>
        </table>
      </div>
    </Fragment>
  )
}
